import { jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment-timezone';
import { Component } from 'react';
class PrinterFriendly extends Component {
    render() {
        var _a;
        const { currentOriginalEmail } = this.props.originalEmail;
        // `contactform` resources does not seem to have `msg` object
        // and have everything in root.
        const msg = (currentOriginalEmail === null || currentOriginalEmail === void 0 ? void 0 : currentOriginalEmail.msg) || currentOriginalEmail;
        if (!msg) {
            return null;
        }
        const to = Array.isArray(msg.to)
            ? msg.to.map((t) => `${t.join(', ')}\n`)
            : '';
        const subject = msg.subject;
        const fromName = msg.from_name;
        const fromEmail = msg.from_email;
        const date = (_a = msg.headers) === null || _a === void 0 ? void 0 : _a.Date;
        const humanDate = date ? moment(date).local().format('LLLL') : '';
        return (_jsx("div", { children: _jsx("iframe", { className: "hidden", srcDoc: `
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tbody>
                  <tr>
                    <td colspan="2" style="font-size: small;color: #777;text-align:right">
                      <b>${fromName} ${fromEmail}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <hr />
                      <font size="+1"><b>${subject}</b></font><br>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size: small;">
                      ${to}
                    </td>
                    <td style="text-align:right">
                      ${humanDate}
                    </td>
                  </tr>
                </tbody>
              </table>
              ${this.props.htmlIframeSrc}
              `, style: { border: '0', width: '100%', height: '100vh' }, id: "printer-friendly" }) }));
    }
}
export default PrinterFriendly;
